import ListingEditStepWrapper from './ListingEditStepWrapper.component';

export default ListingEditStepWrapper;